import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from 'firebase/firestore/lite';

import { SelectSurveyAnswer } from '../types/selectSurveyAnswer';
import { firestore } from '../utils/firebase';

export default class SelectSurveyAnswerApi {
  private static readonly collectionReference = collection(firestore, 'selectSurveyAnswers');

  public static async addSurveyAnswer(newSurveyAnswer: Omit<SelectSurveyAnswer, 'id' | 'created'>) {
    const docRef = doc(this.collectionReference);
    await setDoc(docRef, {
      ...newSurveyAnswer,
      id: docRef.id,
      created: serverTimestamp(),
    });
    return docRef.id;
  }

  public static async updateSurveyAnswer(updatedSurveyAnswer: SelectSurveyAnswer) {
    const docRef = doc(this.collectionReference, updatedSurveyAnswer.id);
    await updateDoc(docRef, { ...updatedSurveyAnswer });
    return updatedSurveyAnswer;
  }

  public static async addOrUpdateSurveyAnswer(newSurveyAnswer: Omit<SelectSurveyAnswer, 'id' | 'created'>) {
    const answer = await this.getUserAnswerForContent(newSurveyAnswer.surveyContentId, newSurveyAnswer.userId);
    if (answer) {
      await this.updateSurveyAnswer({ ...newSurveyAnswer, id: answer.id, created: answer.created }); // TODO: maybe created should be datetime.now?
    } else {
      await this.addSurveyAnswer(newSurveyAnswer);
    }
  }

  public static async getSurveyAnswer(id: string) {
    const docRef = doc(this.collectionReference, id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      return null;
    }
    return {
      ...docSnap.data(),
      id: docSnap.id,
      created: docSnap.data().created.toDate(),
    } as SelectSurveyAnswer;
  }

  public static async getUserAnswerForContent(surveyContentId: string, userId: string) {
    const querySnap = await getDocs(
      query(this.collectionReference, where('surveyContentId', '==', surveyContentId), where('userId', '==', userId))
    );
    if (querySnap.docs.length === 0) return null;
    const docSnap = querySnap.docs[0];
    return {
      ...docSnap.data(),
      id: docSnap.id,
      created: docSnap.data().created.toDate(),
    } as SelectSurveyAnswer;
  }
}
